import { gql } from 'graphql-tag'

export const getEntityWithChildrenPaginatedQuery = gql`
  query GetEntity($id: Int!, $page: Int, $perPage: Int) {
    getEntity(id: $id) {
      id
      childrenCount
      name
      ancestry
      ancestryDetails {
        id
        name
      }
      type
      userCount
      children(page: $page, perPage: $perPage) {
        childrenCount
        id
        name
        ancestry
        userCount
        degree
      }
    }
  }
`

export const getEntityReadersPaginated = gql`
  query GetEntityReadersPaginated($id: Int!, $page: Int, $perPage: Int) {
    getEntity(id: $id) {
      id
      readersPerPage(page: $page, perPage: $perPage) {
        accessExpireDate
        accessToken
        email
        id
        name
        permissions
        teacherId
        teacherPermissions
        userId
      }
    }
  }
`

export const getEntityBasicInfo = gql`
  query GetEntityBasicInfo($id: Int!) {
    getEntity(id: $id) {
      id
      name
      ancestry
      ancestryDetails {
        id
        name
      }
      type
    }
  }
`

export const getReadersLastPresenceEvent = gql`
  query GetReadersLastPresenceEvent($id: Int!, $page: Int, $perPage: Int) {
    getEntity(id: $id) {
      id
      readersPerPage(page: $page, perPage: $perPage) {
        id
        name
        lastPresenceEvent {
          createdAt
          name
        }
      }
    }
  }
`

export const getEntityReadersWithLastRunningRecords = gql`
  query GetEntityReadersWithLastRunningRecords(
    $id: Int!
    $perPage: Int
    $page: Int
  ) {
    getEntity(id: $id) {
      id
      userCount
      readersPerPage(perPage: $perPage, page: $page) {
        id
        name
        userId
        lastRunningRecordsResult {
          lastAssessmentDate
          currentLeveling
        }
      }
    }
  }
`

export const getEntityChildrenWithBasicInfoPaginated = gql`
  query GetEntityChildrenWithBasicInfoPaginated(
    $id: Int!
    $perPage: Int!
    $page: Int!
  ) {
    getEntity(id: $id) {
      id
      degree
      children(perPage: $perPage, page: $page) {
        id
        name
        degree
        type
      }
    }
  }
`

export const getEntitiesByAncestryQuery = gql`
  query GetEntitiesByAncestry($rootId: String!) {
    getEntitiesByAncestry(rootId: $rootId) {
      id
      name
      ancestry
    }
  }
`
